<template>
  <v-container class="page">
    <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>
<p style="text-align: center;"><strong>UMOWA NAJMU SPRZĘTU MUZYCZNEGO</strong></p>
<p>Zawarta dnia ............... w Łodzi pomiędzy:
<br><strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego 
Rejestru Sądowego, prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP 727-28-12-193,
 REGON 366891567, o kapitale zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez:Prezesa zarządu - Piotra Grzelaka,uprawnionego do samodzielnej 
 reprezentacji zwanym w dalszej części Umowy <b>,,Wynajmującym’’,</b>
<p></p>
<p> a Panem/Panią: {{nabywca }}<br>
Adres zamieszkania: {{adres }}<br>
Seria i numer dowodu osobistego:……………………………………………,<br>
PESEL:……………………………………………………, <br>
będącym rodzicem lub opiekunem prawnym Dziecka:<br>
Imię i Nazwisko Dziecka:……………………………………………………………………………………………………………,<br>
Szkoła……………………………………………………………………………………………………………,<br>
Klasa………………, zwanym w dalszej części umowy <b>,,Najemcą’’,</b><br>
<p></p><p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong></p>
<ol>
  <li>
    Wynajmujący oświadcza, że jest właścicielem sprzętu muzycznego, stanowiącego przedmiot najmu, zwanego w dalszej części Umowy <b>,,Zestawem gitarowym”</b>.
  </li>
  <p></p>
  <li>
    Wynajmujący oświadcza, że oddaje Najemcy do używania zestaw gitarowy, w skład którego wchodzi:
  </li>
 <ol type="a">
<li>Gitara {{modelGitary}}</li>
<li>Pokrowiec</li></ol>
</ol>
<p>Łączna wartość zestawu gitarowego wynosi 350,00 zł (słownie:trzysta pięćdziesiąt).</p>
<p></p><p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong></p>
<ol>
<li>
 Wynajmujący oświadcza, iż zestaw gitarowy będący przedmiotem najmu jest kompletny i sprawny technicznie, a Najemca zobowiązuje się do sprawdzenia stanu technicznego
 Zestawu gitarowego w zakresie prawidłowości jego funkcjonowania oraz widocznych wad i uszkodzeń przed podpisaniem niniejszej umowy.
</li>
<p></p>
<li>
 Wynajmujący zobowiązuje się do przekazania Najemcy przedmiotu najmu w dniu podpisania niniejszej umowy. Przekazanie odbędzie się za pośrednictwem dowolnie wybranej
 przez Wynajmującego firmy kurierskiej na koszt Najemcy.
</li>
<p></p>
<li>
 Najemca zobowiązuje się do korzystania z zestawu gitarowego zgodnie z zasadami prawidłowej eksploatacji.
</li>
<p></p>
<li>
 Najemca zobowiązuje się do dokonywania napraw i konserwacji niezbędnych do zachowania zestawu gitarowego w stanie niepogorszonym, z uwzględnieniem jego zużycia 
 będącego skutkiem prawidłowego użytkowania. Zestaw może nosić ślady użytkowania.
</li>
<p></p>
<li>
 Najemca ponosi pełną odpowiedzialność za zdarzenia wynikłe z nieodpowiedniego korzystania z zestawu gitarowego.
</li>
<p></p>
<li>
Najemca nie może oddać zestawu gitarowego do używania na podstawie odpłatnego bądź nieodpłatnego stosunku prawnego osobie trzeciej bez uprzedniej zgody Wynajmującego
wyrażonej na piśmie.
</li>
</ol>
<p></p><p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3</strong></p>
<ol>
<li>
  Strony ustalają, iż  opłata z tytułu najmu zestawu gitarowego będzie wynosiła 25 zł (słownie: dwadzieścia pięć złotych) za każdy pełny miesiąc. 
  Do opłaty za pierwszy miesiąc najmu zostanie doliczona kwota 16 zł tytułem opłaty za wysłanie zestawu gitarowego Najemcy.
</li>
<p></p>
<li>
  Opłatę, o której mowa w § 3 ust. 1 należy uiszczać z góry do 10-go dnia każdego miesiąca na konto bankowe Wynajmującego: <b>76 1090 2590 0000 0001 3433 5287</b>
  w tytule przelewu podając: Wynajem gitary, imię i nazwisko dziecka oraz klasę.
</li>
<p></p>
<li>
  Dniem zapłaty jest dzień uznania rachunku bankowego Wynajmującego kwotą miesięcznej opłaty za najem.
</li>
<p></p>
<li>
  W przypadku zwłoki w dokonywaniu miesięcznych opłat Wynajmującemu przysługuje prawo rozwiązania niniejszej umowy bez zachowania okresu wypowiedzenia oraz
  naliczenia kary umownej o której mowa § 5 ust.4
</li>
</ol>
<p></p><p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4</strong></p>
<ol>
<li>
  Niniejsza umowa zostaje zawarta na czas nieokreślony <b>od dnia jej podpisania przez obie Strony z możliwością jej wypowiedzenia.</b>
</li>
<p></p>
<li>
  Strony mogą wypowiedzieć niniejszą umowę w formie pisemnej, ze skutkiem na koniec miesiąca, w którym wypowiedzenie zostało skutecznie doręczone drugiej stronie.
</li>
<p></p>
<li>
  Najemca z chwilą rozwiązania niniejszej umowy, zobowiązany jest do niezwłocznego zwrotu zestawu gitarowego Wynajmującemu, jednak nie później 
  7-go dnia kalendarzowego liczonego od daty zakończenia umowy.
</li>
<p></p>
<li>
  Zestaw gitarowy należy zwrócić na adres Wynajmującego: <b>Tutore Poland Sp. z o.o. ul. Piotrkowska 157A, 90-440 Łódź.</b>
</li>
<p></p>
<li>
  Najemca ponosi wszelkie koszty oraz ponosi pełną odpowiedzialność związaną z dostarczeniem zestawu gitarowego Wynajmującemu.
</li>
<p></p>
<li>
  Zwrot przedmiotu umowy jest skuteczny, w chwili gdy Wynajmujący otrzyma zestaw gitarowy.
</li>
<p></p>
<li>
  W przypadku braku zwrotu zestawu gitarowego po rozwiązaniu umowy w terminie wskazanym w § 4 ust. 3. lub w sytuacji, gdy zwrócony zestaw gitarowy będzie uszkodzony,
  Wynajmujący może nałożyć na Najemcę karę w wysokości ustalonej w § 5 ust.4.
</li>
<p></p>
<li>
  Najemca ma obowiązek zwrócić Wynajmującemu przedmiot najmu, na własny koszt, w stanie niepogorszonym, poza normalnym stopniem zużycia wynikającym z prawidłowej
  eksploatacji.
</li>
</ol>
<p></p><p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5</strong></p>
  Wynajmujący ma prawo rozwiązać niniejszą umowę, bez zachowania okresu wypowiedzenia w sytuacji gdy Najemca:
<li>
 zalega z opłatą za najem za jeden okres płatności powyżej 14 dni;
</li>
<li>
 użytkuje zestaw gitarowy niezgodnie z jego przeznaczeniem;
</li>
<li>
 uprzekazał zestaw gitarowy osobie trzeciej bez uprzedniej zgody Wynajmującego.
</li>
<li>
 Wynajmujący ma prawo do nałożenia kary umownej za niedostarczenie lub uszkodzenie zestawu gitarowego w wysokości 500 zł (słownie: pięćset złotych).
 Najemca jest zobowiązany do uregulowania nałożonej kary w terminie 14 dni od daty rozwiązania umowy.
</li>
<p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6</strong></p>
<ol>
<li>
  Zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.
</li>
<li>
  W sprawach nieuregulowanych zapisami niniejszej umowy mają zastosowanie przepisy Kodeksu Cywilnego.
</li>
</ol>
<p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7</strong></p>
Właściwym do rozpoznania sporów wynikających z niniejszej umowy będzie Sąd właściwy dla miejsca siedziby Wynajmującego.
<p></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8</strong></p>
Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.
<p></p>
<div class="cointainer" style="margin-top: 130px;">
    <div class="left-cointainer">
        <span style="margin-right: 30%;">.................................</span>
        <span style="margin-left: 10%;">Wynajmujący</span>
    </div>
    <div class="right-cointainer">
        <span style="margin-right: 30%;">............................</span>
        <span style="margin-left: 10%;">Najemca</span>
    </div>
</div>
<div style="page-break-before: always;"></div>
<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
 <div class="left-cointainer">
  <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
 </div>
 <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
 </div>
 </div>
 <div class="right-cointainer">
   <span style="margin-left: 80%;">.......................</span>,Łódź
 </div>    
<p></p>
<p style="text-align: center;"><strong>Formularz zwrotu wynajmu zestawu gitarowego</strong></p>
Ja niżej podpisany/a ...................................... zwrot zestawu gitarowego zamówionego za pośrednictwem firmy <strong>Tutore Poland Sp. z o.o.</strong>
w dniu .................. 
Zgodnie z umową, oświadczam, że instrument jest w stanie niepogorszonym.<br>
numer zamówienia - ......................... <br>
<br>
<br>
<br>
  <div class="right-cointainer">
    <span style="margin-left: 80%;">.......................................</span>
    <span style="margin-left: 80%;">Podpis zwracającego</span>
  </div>  
</v-container>
</template>

<script>
export default {
  name: 'UmowaLeasing',
  props: {
    nabywca: String,
    adres: String,
    zestaw: String,
    wartosczamowienia: String,
    przesylka: String,
    raty: String,
    modelGitary: String,
    caloscZaLeasing: String
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
    this.$nextTick(() => {
      window.setTimeout(() => window.print(), 500)
    })
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 3,5px;
  padding-top: 3,5px;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaLeasing.vue